export const STATIC_META_CONSTANTS = {
    CONTACTUS: "contactus",
    PRIVACYPOLICY: "privacyPolicy",
    TERMSOFPURCHASE: "termsofpurchase",
    CARS24WAY: "cars24way",
    TERMSOFUSE: "termsofuse",
    CARRER: "carrer",
    ABOUTUS: "aboutus",
    WISHLIST: "wishlist",
    THREEHUNDRED: "threeHundred",
    FINANCE: "finance",
    SITEMAP: "sidemap",
    WARRANTY: "warranty",
    TERMSOFSALE: "termsofsale",
    TRADEIN: "trade-in",
    CARHISTORYREPORT: "carhistoryreport",
    MY_ACCOUNT: "myAccount",
    MY_BOOKINGS: "myBookings",
    MY_SELL_ORDERS: "mySellOrders",
    PRIVACY_POLICY_STATEMENT: "privacyPolicyStatement",
    CHR_TERMS_OF_PURCHASE: "chrTermsOfPurchase",
    CARS24_COVER: "cars24Cover",
    REVIEWS: "reviews",
    GET_PRE_APPROVAL: "getPreApproval"
};

export default {
    [STATIC_META_CONSTANTS.CONTACTUS]: {
        "title": "Cars24 Australia | Contact Us",
        "description": ""
    },
    [STATIC_META_CONSTANTS.PRIVACYPOLICY]: {
        "title": "Privacy Policy | Cars24 Australia",
        "description": "Learn how Cars24 Australia collects, uses and protects your personal and credit-related information in line with the Privacy Act 1988 and APPs."
    },
    [STATIC_META_CONSTANTS.PRIVACY_POLICY_STATEMENT]: {
        "title": "Cars24 | Privacy Policy"
    },
    [STATIC_META_CONSTANTS.TRADEIN]: {
        "title": "Cars24 | Trade-in your car",
        "description": ""
    },
    [STATIC_META_CONSTANTS.TERMSOFPURCHASE]: {
        "title": "Terms of Purchase | Buy a Used Car from Cars24",
        "description": "Review Cars24's terms for buying a used car, including cooling-off rights, statutory warranty, delivery, the 30-Day Return Guarantee and payment terms."
    },
    [STATIC_META_CONSTANTS.CHR_TERMS_OF_PURCHASE]: {
        "title": "Cars24 | Terms of Purchase"
    },
    [STATIC_META_CONSTANTS.CARS24WAY]: {
        "title": "Cars24 | The Cars24 way",
        "description": "Buy a used car 100% online the Cars24 way. Quality assured used cars with easy finance, 7-day return & 100% money back guarantee."
    },
    [STATIC_META_CONSTANTS.TERMSOFUSE]: {
        "title": "Terms of Use | Cars24 Australia",
        "description": "Read the terms and conditions governing your use of the Cars24 website, services and the Cars24 Marketplace platform in Australia."
    },
    [STATIC_META_CONSTANTS.CARRER]: {
        "title": "Careers at Cars24 Australia | Join Our Team",
        "description": "Explore career opportunities at Cars24 Australia. See our values, employee benefits and current openings across Melbourne, Sydney and Brisbane.",
        url: "/career"
    },
    [STATIC_META_CONSTANTS.ABOUTUS]: {
        "title": "Cars24 | About Us",
        "description": "We're here to transform the way that Australia buys and sells used cars, making it as easy and convenient as any other online purchase."
    },
    [STATIC_META_CONSTANTS.WISHLIST]: {
        "title": "Cars24 - Buy quality used cars 100% online in Australia"
    },
    [STATIC_META_CONSTANTS.THREEHUNDRED]: {
        "title": "Cars24 - Buy quality used cars 100% online in Australia"
    },
    [STATIC_META_CONSTANTS.FINANCE]: {
        "title": "Cars24 | Finance",
        "metaTitle": "Used Car Loan & Finance Australia: Apply Online Now",
        "description": "Looking for hassle-free used car loans and finance in Australia? Apply online now at Cars24 to get quick approval and competitive rates. Drive home your dream car with ease!"
    },
    [STATIC_META_CONSTANTS.SITEMAP]: {
        "title": "Cars24 | Sitemap"
    },
    [STATIC_META_CONSTANTS.WARRANTY]: {
        "title": "Cars24 | Warranty"
    },
    [STATIC_META_CONSTANTS.CARS24_COVER]: {
        "title": "Cars24 Cover | Extended Car Warranty",
        "description": "Protect your used car beyond the included 3-month warranty with Cars24 Cover, extended mechanical and electrical protection backed by a national repair network."
    },
    [STATIC_META_CONSTANTS.TERMSOFSALE]: {
        "title": "Terms of Sale | Sell Your Car to Cars24",
        "description": "Read Cars24's terms and conditions for selling your car to us, covering seller warranties, title transfer, PPSA security interests and completion."
    },
    [STATIC_META_CONSTANTS.REVIEWS]: {
        "title": "Customer Reviews | Cars24 Australia",
        "description": "See 6,000+ verified 4 and 5-star reviews from real customers who've bought or sold a used car online with Cars24 Australia.",
        url: "/reviews/"
    },
    [STATIC_META_CONSTANTS.GET_PRE_APPROVAL]: {
        "title": "Get Pre-Approved for a Car Loan | Cars24",
        "description": "Check your car loan eligibility in 2 minutes with no impact to your credit score. 100% online pre-approval with competitive interest rates."
    },
    [STATIC_META_CONSTANTS.CARHISTORYREPORT]: {
        "title": "Car History Check Australia | Instant Vehicle Report | Cars24",
        "description": "Run a car history check today. Get instant vehicle history reports covering PPSR, finance owing, written-off status, recalls, odometer check & more in Australia."
    },
    [STATIC_META_CONSTANTS.MY_ACCOUNT]: {
        "title": "My Account | CARS24"
    },
    [STATIC_META_CONSTANTS.MY_BOOKINGS]: {
        "title": "My Bookings | CARS24"
    },
    [STATIC_META_CONSTANTS.MY_SELL_ORDERS]: {
        "title": "My Sell Orders | CARS24"
    }
};
